<template>
  <div id="members" class="module">
    <h1>Members</h1>

    <el-card class="box-card" v-if="Users">
      <div v-for="(role, role_ix) in orderedRoles" :key="`role-${role_ix}`">
        <div v-if="Users[role]">
          <h2>{{ role }}</h2>

          <hr />

          <el-row :gutter="40">
            <el-col
              :span="12"
              v-for="(Member, member_ix) in Users[role]"
              :key="`${role}-member-${member_ix}`"
            >
              <MemberBlock :Member="Member" :index="role_ix + member_ix" />
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import ApolloCompanyMembers from "@/graphql/Company/Members.gql";

export default {
  name: "Members",
  components: {
    MemberBlock: () => import("@/components/MemberBlock.vue")
  },
  asyncComputed: {
    Users() {
      const Company = this.Company;
      let Users = {};

      if (Company.Users === undefined) return false;

      Company.Users.map(User => {
        if (User.Roles === undefined) return false;

        User.Roles.map(Role => {
          if (!(Role.type in Users)) {
            Users[Role.type] = [];
          }

          Users[Role.type].push(User);
        });
      });

      return Users;
    }
  },
  apollo: {
    Company: {
      query: ApolloCompanyMembers,
      variables() {
        return {
          companyName: this.$store.state.company.name
        };
      },
      update(data) {
        return data.Company[0];
      }
    }
  },
  data() {
    return {
      Company: [],
      orderedRoles: ["Primary", "Secondary", "Invoicing", "Other"]
    };
  }
};
</script>

<style lang="scss" scoped>
h2 {
  margin-top: 3rem;

  &:not(:first-of-type) {
    margin-top: 5rem;
  }
}

hr {
  margin-top: 2rem;
}
</style>
